module.exports = __webpack_public_path__ + "img/norcott_b4.d0f7a0c0.jpg";